<template>
    <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
        <side-bar :background-color="sidebarBackground"
                  short-title="Carepoint"
                  title="Carepoint Pharma Portal">
            <template slot="links">
                <sidebar-item :link="{name: 'Company Stats',icon: 'ni ni-tv-2 text-primary',path: '/dashboard'}" />

                <sidebar-item :link="{name: 'Prescriber Stats', icon: 'ni ni-single-02 text-yellow', path: '/individualstats'}" />
                <!--<sidebar-item :link="{name: 'Payer Performance', icon: 'ni ni-money-coins text-success', path: '/payerperformance'}" />-->
                <sidebar-item v-if="loggedInUser.roles && (loggedInUser.roles.includes('Admin') || loggedInUser.roles.includes('admin'))" :link="{name: 'User Management', icon: 'ni ni-badge text-danger', path: '/profile'}" />
                <sidebar-item :link="{name: 'Carepoint Pricing', icon: 'ni ni-money-coins text-success', path: '/pricing'}" />
                <!--<sidebar-item :link="{name: 'Tables', icon: 'ni ni-bullet-list-67 text-red', path: '/tables'}"/>-->
                <!--<sidebar-item :link="{name: 'Login', icon: 'ni ni-key-25 text-info', path: '/login'}"/>
                <sidebar-item :link="{name: 'Register', icon: 'ni ni-circle-08 text-pink', path: '/register'}"/>-->

            </template>
        </side-bar>
        <div class="main-content" :data="sidebarBackground">
            <dashboard-navbar></dashboard-navbar>

            <div @click="toggleSidebar">
                <fade-transition :duration="200" origin="center top" mode="out-in">
                    <!-- your content here -->
                    <router-view></router-view>
                </fade-transition>
                <!--<content-footer v-if="!$route.meta.hideFooter"></content-footer>-->
            </div>
        </div>
    </div>
</template>
<script>
    import DashboardNavbar from './DashboardNavbar.vue';
    //import ContentFooter from './ContentFooter.vue';
    import { FadeTransition } from 'vue2-transitions';

    export default {
        components: {
            DashboardNavbar,
            //ContentFooter,
            FadeTransition
        },
        data() {
            return {
                loggedInUser: {
                    username: '',
                    name: '',
                    email: '',
                    roles: '',
                    zones: '',
                    company: ''
                },
                sidebarBackground: 'primary'
            };
        },
        methods: {
            toggleSidebar() {
                if (this.$sidebar.showSidebar) {
                    this.$sidebar.displaySidebar(false);
                }
            },
            getUserList() {
                this.axios.get('Users/list')
                    .then(response => {
                        this.users = response.data;
                    })
                    .catch(error => {

                        this.users = [];
                    })
                    .finally(() => {
                        // final cleanup
                    });
            },
        },
        mounted() {
            this.getUserList();
            this.$Amplify.Auth.currentUserInfo()
                .then(data => {
                    if (data) {

                        this.loggedInUser.username = data.username;
                        this.loggedInUser.email = data.attributes.email;
                        this.loggedInUser.name = data.attributes.name;
                        this.loggedInUser.roles = data.attributes["custom:Roles"];
                        this.loggedInUser.zones = data.attributes["custom:Zones"];
                        this.loggedInUser.company = data.attributes["custom:Company"];
                    } else {
                        this.loggedInUser.username = '';
                        this.loggedInUser.email = '';
                        this.loggedInUser.name = '';
                        this.loggedInUser.roles = '';
                        this.loggedInUser.zones = '';
                    }
                });
        },
    };
</script>
<style lang="scss">
</style>
